@for (alert of alerts(); track alert.id) {
  <div class="alert alert-{{ alert.type }} alert-dismissible fade show" role="alert">
    {{ alert.message }}
    <button type="button" class="btn-close" (click)="remove(alert.id)" aria-label="Close"></button>
  </div>
}
